import { render, staticRenderFns } from "./EditarCategoriaDialog.vue?vue&type=template&id=6eff9be8"
import script from "./EditarCategoriaDialog.vue?vue&type=script&lang=js"
export * from "./EditarCategoriaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports